import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyDqlmodqis4a4gsYIA5tIw6Kv2x7vVS7Y4",
    authDomain: "boovieplex-ccc62.firebaseapp.com",
    projectId: "boovieplex-ccc62",
    storageBucket: "boovieplex-ccc62.appspot.com",
    messagingSenderId: "435096821724",
    appId: "1:435096821724:web:133724485a107704dab919",
    measurementId: "G-MJ7KTZ2S2W"
    };

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();

export default db;